import {
  Component,
  effect,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output, signal,
  ViewChild
} from '@angular/core';
import {MatPaginator, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatRow, MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {PersonBadgeComponent} from '../../common/person-picker/person-badge/person-badge.component';
import {Contact} from '../../../models/contact';
import {ContactCompleteColorPipe, ContactCompletePipe} from '../contact-complete.pipe';
import {AssignPersonComponent} from '../../common/assign-person/assign-person.component';
import {MatDialog} from '@angular/material/dialog';
import {ContactService} from '../../services/contact.service';
import {MatProgressSpinner, MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {toFilter} from '../../utils';
import {CdkTableModule} from '@angular/cdk/table';

export type ContactData = Contact & {
  loadingAssignee: boolean;
  _status?: string;
  _assignee?: string;
  _name?: string;
  _bairro?: string;
  _annotations?: string;
}

@Component({
  selector: 'app-contact-table',
  styleUrl: 'contact-table.component.scss',
  templateUrl: 'contact-table.component.html',
  imports: [MatFormFieldModule, MatRow, MatInputModule, CdkTableModule, MatTableModule, MatProgressSpinnerModule, MatSortModule, MatPaginatorModule, MatIcon, MatIconButton, PersonBadgeComponent, ContactCompleteColorPipe, ContactCompletePipe, MatProgressSpinner],
  standalone: true
})
export class ContactTable implements OnInit {
  displayedColumns: string[] = ['_name', '_bairro', '_assignee', '_status', 'open'];
  dataSource: MatTableDataSource<ContactData> = new MatTableDataSource([] as ContactData[]);
  contactService = inject(ContactService);

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  @Output() openDetails: EventEmitter<string> = new EventEmitter();
  @Output() pageChange: EventEmitter<PageEvent> = new EventEmitter();

  values = input.required<Contact[]>();
  totalItems = input<number>(0);
  pageSize = input<number>(10);

  constructor() {
    effect(() => {
      this.update();
    });
  }

  update() {
    this.dataSource.data = this.values()
      .filter((value) => !value.deletedAt)
      .map((value) => this.createNewContact(value));
  }

  ngOnInit() {
    this.update();
    setTimeout(() => {
      this.dataSource.sort = this.sort ?? null;
    }, 0);
  }

  onPageChange(event: PageEvent) {
    this.pageChange.emit(event);
  }

  readonly dialog = inject(MatDialog);

  openDialog(contact: ContactData): void {
    contact.loadingAssignee = true;
    const dialogRef = this.dialog.open(AssignPersonComponent, {
      width: '400px',
      height: '100px',
      data: {},
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result && result.assignee) {
        await this.contactService.updateContactAssignee(contact.id, result.assignee);
      }
      contact.loadingAssignee = false;
    });
  }

  createNewContact(contact: Contact): ContactData {
    return {
      ...contact,
      loadingAssignee: false,
      _status: new ContactCompletePipe().transform(contact),
      _assignee: toFilter(contact.assigneeUser?.name),
      _name: toFilter(contact.name),
      _bairro: toFilter(contact.bairro),
      _annotations: toFilter(contact.delta ? contact.delta.map((d: any) => d.insert).join(' ').replaceAll('\n',' ') : ''),
    };
  }
}

